module.exports = __webpack_public_path__ + "static/img/sad.32b00a4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sad.gif
// module id = 6liF
// module chunks = 11